import { Route, Switch } from 'react-router-dom';

import { OrderHistoryPage } from 'features/order-history/pages/OrderHistoryPage';
import { orderHistoryPaths } from 'features/order-history/routes/paths';

export const OrderHistoryRouter = () => {
  return (
    <Switch>
      <Route path={orderHistoryPaths.static.root} component={OrderHistoryPage} />
    </Switch>
  );
};
